import bannerAnimationData from "../animations/common_main_banner_lottie/Refer_and_earn_banner_lottie.json";
import Common_main_banner from '../common_components/common_banner/common_main_banner/Common_main_banner';
import Contribution from '../home/contribution/Contribution';
import Invite from './invite/Invite';
import Referal_steps from './referal_step/Referal_steps';

function Refer_and_earn() {
    const bannerSlides = [
        {
            heading: "INVITE & EARN",
            subheading: "Share your referral link with friends & earn exciting rewards when they join."
        },
        {
            heading: "REFER MORE, EARN MORE",
            subheading: "Get additional bonuses for every successful referral — the more you share, the more you earn."
        },
        {
            heading: "YOUR FRIENDS WIN TOO!",
            subheading: "Your friends get instant signup benefits when they join through your referral link."
        },
        {
            heading: "TRACK YOUR REWARDS",
            subheading: "Monitor your referral progress and reward status easily from your account dashboard."
        }
    ];

    return (
        <>
            <Common_main_banner
                animationData={bannerAnimationData}
                slides={bannerSlides}
            />
            <Referal_steps />
            <Invite />
            <Contribution />
        </>
    );
}

export default Refer_and_earn;
